export const macroScoreColors = ["#FC695C", "#FD9858", "#E9DA61", "#2d97fc", "#91daa1", "#8BDA9C"];
export const spectralColors = ["#f04829", "#faaf40", "#2d97fc"];

export const macroScoreRanges = [
  [300, 410], // red
  [411, 520], // orange
  [521, 599], // yellow
  [600, 639], //blue
  [631, 740], // light green
  [741, 850], // green
];

export const getScoreRangeBasedOnReasonCode = (code?: number): number => {
  const totalCodes = 7;
  const max = 850;
  if (code) {
    return (max / totalCodes) * code;
  }
  return 500;
};

export function inRange(x: number, min: number, max: number): boolean {
  return (x - min) * (x - max) <= 0;
}

export function calculateTickByMacroScore(score: number): number {
  const tickSelected = macroScoreRanges
    .map(([min, max], idx) => {
      if (inRange(score, min, max)) return idx + 1;
      return null;
    })
    .filter((r) => !!r)?.[0];
  return (tickSelected as number) - 1 || 0;
}
